import React from 'react';
import { Link } from 'react-router-dom';
import { useThemeStore } from '../stores/themeStore';

function Footer() {
  const { darkMode } = useThemeStore();
  
  return (
    <div className={`fixed bottom-4 right-4 text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'} hidden lg:block`}>
      <p className="flex flex-wrap justify-end gap-x-4">
        <span>
          Application créée par Samuel LUCAS
          <span className="ml-1">&copy; {new Date().getFullYear()}</span>
        </span>
        <Link to="/rgpd" className="hover:underline">Conformité RGPD</Link>
        <span className={`text-xs ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}>Ver.1.3</span>
      </p>
    </div>
  );
}

export default Footer;